var map = {
	"./activity/202408tr/Copyright/index.js": "./pages/activity/202408tr/Copyright/index.js",
	"./activity/202408tr/Countdown/index.js": "./pages/activity/202408tr/Countdown/index.js",
	"./activity/202408tr/GroupList/index.js": "./pages/activity/202408tr/GroupList/index.js",
	"./activity/202408tr/List/index.js": "./pages/activity/202408tr/List/index.js",
	"./activity/202408tr/Nav/index.js": "./pages/activity/202408tr/Nav/index.js",
	"./activity/202408tr/Nav2/index.js": "./pages/activity/202408tr/Nav2/index.js",
	"./activity/202408tr/Prize/index.js": "./pages/activity/202408tr/Prize/index.js",
	"./activity/202408tr/Rule/index.js": "./pages/activity/202408tr/Rule/index.js",
	"./activity/202408tr/Top/index.js": "./pages/activity/202408tr/Top/index.js",
	"./activity/202408tr/index.js": "./pages/activity/202408tr/index.js",
	"./activity/202408tr/lang.js": "./pages/activity/202408tr/lang.js",
	"./activity/allGamRank/index.js": "./pages/activity/allGamRank/index.js",
	"./activity/allGamRank/lang.js": "./pages/activity/allGamRank/lang.js",
	"./activity/beta/index.js": "./pages/activity/beta/index.js",
	"./activity/caserule/index.js": "./pages/activity/caserule/index.js",
	"./activity/caserule/lang.js": "./pages/activity/caserule/lang.js",
	"./activity/couples/index.js": "./pages/activity/couples/index.js",
	"./activity/couples/lang.js": "./pages/activity/couples/lang.js",
	"./activity/couplesNew/index.js": "./pages/activity/couplesNew/index.js",
	"./activity/couplesNew/lang.js": "./pages/activity/couplesNew/lang.js",
	"./activity/cp-yes/index.js": "./pages/activity/cp-yes/index.js",
	"./activity/cp-yes/lang.js": "./pages/activity/cp-yes/lang.js",
	"./activity/dailytasks/index.js": "./pages/activity/dailytasks/index.js",
	"./activity/dailytasks/lang.js": "./pages/activity/dailytasks/lang.js",
	"./activity/dailytasks/tasks.js": "./pages/activity/dailytasks/tasks.js",
	"./activity/eid-activities/index.js": "./pages/activity/eid-activities/index.js",
	"./activity/eid-activities/lang.js": "./pages/activity/eid-activities/lang.js",
	"./activity/eid-al-Adha/index.js": "./pages/activity/eid-al-Adha/index.js",
	"./activity/eid-al-Adha/lang.js": "./pages/activity/eid-al-Adha/lang.js",
	"./activity/eidaladha/index.js": "./pages/activity/eidaladha/index.js",
	"./activity/eidaladha/lang.js": "./pages/activity/eidaladha/lang.js",
	"./activity/family/index.js": "./pages/activity/family/index.js",
	"./activity/family/lang.js": "./pages/activity/family/lang.js",
	"./activity/familyLevel/index.js": "./pages/activity/familyLevel/index.js",
	"./activity/familyLevel/lang.js": "./pages/activity/familyLevel/lang.js",
	"./activity/fruit1103/UserList/index.js": "./pages/activity/fruit1103/UserList/index.js",
	"./activity/fruit1103/history.js": "./pages/activity/fruit1103/history.js",
	"./activity/fruit1103/index.js": "./pages/activity/fruit1103/index.js",
	"./activity/fruit1103/lang.js": "./pages/activity/fruit1103/lang.js",
	"./activity/fruit1103/rank.js": "./pages/activity/fruit1103/rank.js",
	"./activity/fruit1103/rule.js": "./pages/activity/fruit1103/rule.js",
	"./activity/goldRubyRecharge/index.js": "./pages/activity/goldRubyRecharge/index.js",
	"./activity/goldRubyRecharge/lang.js": "./pages/activity/goldRubyRecharge/lang.js",
	"./activity/hobiRecharge/index.js": "./pages/activity/hobiRecharge/index.js",
	"./activity/hobiRecharge/lang.js": "./pages/activity/hobiRecharge/lang.js",
	"./activity/hobiRecharge/reward-item.js": "./pages/activity/hobiRecharge/reward-item.js",
	"./activity/kingqueen/index.js": "./pages/activity/kingqueen/index.js",
	"./activity/labor/index.js": "./pages/activity/labor/index.js",
	"./activity/labor/lang.js": "./pages/activity/labor/lang.js",
	"./activity/ladies/index.js": "./pages/activity/ladies/index.js",
	"./activity/ladies/lang.js": "./pages/activity/ladies/lang.js",
	"./activity/ladiesregister/index.js": "./pages/activity/ladiesregister/index.js",
	"./activity/ladiesregister/lang.js": "./pages/activity/ladiesregister/lang.js",
	"./activity/ladiesregister2/index.js": "./pages/activity/ladiesregister2/index.js",
	"./activity/ladiesregister2/lang.js": "./pages/activity/ladiesregister2/lang.js",
	"./activity/level/index.js": "./pages/activity/level/index.js",
	"./activity/level/lang.js": "./pages/activity/level/lang.js",
	"./activity/lottery/History/index.js": "./pages/activity/lottery/History/index.js",
	"./activity/lottery/Rank/index.js": "./pages/activity/lottery/Rank/index.js",
	"./activity/lottery/Rule/index.js": "./pages/activity/lottery/Rule/index.js",
	"./activity/lottery/Timer/index.js": "./pages/activity/lottery/Timer/index.js",
	"./activity/lottery/index.js": "./pages/activity/lottery/index.js",
	"./activity/lottery/lang.js": "./pages/activity/lottery/lang.js",
	"./activity/monthly-rank/index.js": "./pages/activity/monthly-rank/index.js",
	"./activity/monthly-rank/lang.js": "./pages/activity/monthly-rank/lang.js",
	"./activity/monthly-rank/rewardComp/index.js": "./pages/activity/monthly-rank/rewardComp/index.js",
	"./activity/national-star/certificate-modal/index.js": "./pages/activity/national-star/certificate-modal/index.js",
	"./activity/national-star/countdown/index.js": "./pages/activity/national-star/countdown/index.js",
	"./activity/national-star/fixed-card/index.js": "./pages/activity/national-star/fixed-card/index.js",
	"./activity/national-star/gift/index.js": "./pages/activity/national-star/gift/index.js",
	"./activity/national-star/index.js": "./pages/activity/national-star/index.js",
	"./activity/national-star/lang.js": "./pages/activity/national-star/lang.js",
	"./activity/national-star/last-week/index.js": "./pages/activity/national-star/last-week/index.js",
	"./activity/national-star/loading-svga/index.js": "./pages/activity/national-star/loading-svga/index.js",
	"./activity/national-star/media-modal/index.js": "./pages/activity/national-star/media-modal/index.js",
	"./activity/national-star/no-gift/index.js": "./pages/activity/national-star/no-gift/index.js",
	"./activity/national-star/ranking-item/index.js": "./pages/activity/national-star/ranking-item/index.js",
	"./activity/national-star/rules-rewards/index.js": "./pages/activity/national-star/rules-rewards/index.js",
	"./activity/national-star/sider/index.js": "./pages/activity/national-star/sider/index.js",
	"./activity/national-star/tab-national/index.js": "./pages/activity/national-star/tab-national/index.js",
	"./activity/national-star/tab-nav/index.js": "./pages/activity/national-star/tab-nav/index.js",
	"./activity/national-star/tab-ranking/index.js": "./pages/activity/national-star/tab-ranking/index.js",
	"./activity/national-star/tab-task/index.js": "./pages/activity/national-star/tab-task/index.js",
	"./activity/national-star/toast/index.js": "./pages/activity/national-star/toast/index.js",
	"./activity/national/Available/index.js": "./pages/activity/national/Available/index.js",
	"./activity/national/Countdown/index.js": "./pages/activity/national/Countdown/index.js",
	"./activity/national/Rank/index.js": "./pages/activity/national/Rank/index.js",
	"./activity/national/Reminder/index.js": "./pages/activity/national/Reminder/index.js",
	"./activity/national/Reward/index.js": "./pages/activity/national/Reward/index.js",
	"./activity/national/Treasures/index.js": "./pages/activity/national/Treasures/index.js",
	"./activity/national/index.js": "./pages/activity/national/index.js",
	"./activity/national/lang.js": "./pages/activity/national/lang.js",
	"./activity/nationalTemplate/Banner/index.js": "./pages/activity/nationalTemplate/Banner/index.js",
	"./activity/nationalTemplate/Cd/index.js": "./pages/activity/nationalTemplate/Cd/index.js",
	"./activity/nationalTemplate/Celebration/index.js": "./pages/activity/nationalTemplate/Celebration/index.js",
	"./activity/nationalTemplate/DropScreen/index.js": "./pages/activity/nationalTemplate/DropScreen/index.js",
	"./activity/nationalTemplate/ExtraReward/index.js": "./pages/activity/nationalTemplate/ExtraReward/index.js",
	"./activity/nationalTemplate/Gift/index.js": "./pages/activity/nationalTemplate/Gift/index.js",
	"./activity/nationalTemplate/GiftItem/index.js": "./pages/activity/nationalTemplate/GiftItem/index.js",
	"./activity/nationalTemplate/Header/index.js": "./pages/activity/nationalTemplate/Header/index.js",
	"./activity/nationalTemplate/Rank/index.js": "./pages/activity/nationalTemplate/Rank/index.js",
	"./activity/nationalTemplate/RankPart/index.js": "./pages/activity/nationalTemplate/RankPart/index.js",
	"./activity/nationalTemplate/Reward/index.js": "./pages/activity/nationalTemplate/Reward/index.js",
	"./activity/nationalTemplate/RewardItem/index.js": "./pages/activity/nationalTemplate/RewardItem/index.js",
	"./activity/nationalTemplate/RewardPart/index.js": "./pages/activity/nationalTemplate/RewardPart/index.js",
	"./activity/nationalTemplate/RoomPart/index.js": "./pages/activity/nationalTemplate/RoomPart/index.js",
	"./activity/nationalTemplate/Rule/index.js": "./pages/activity/nationalTemplate/Rule/index.js",
	"./activity/nationalTemplate/Tab/index.js": "./pages/activity/nationalTemplate/Tab/index.js",
	"./activity/nationalTemplate/index.js": "./pages/activity/nationalTemplate/index.js",
	"./activity/nationalTemplate/lang.js": "./pages/activity/nationalTemplate/lang.js",
	"./activity/newLevel/index.js": "./pages/activity/newLevel/index.js",
	"./activity/newLevel/lang.js": "./pages/activity/newLevel/lang.js",
	"./activity/newRamadan/index.js": "./pages/activity/newRamadan/index.js",
	"./activity/newRamadan/lang.js": "./pages/activity/newRamadan/lang.js",
	"./activity/newWeeklyStar/index.js": "./pages/activity/newWeeklyStar/index.js",
	"./activity/newWeeklyStar/lang.js": "./pages/activity/newWeeklyStar/lang.js",
	"./activity/newWeeklyStar/tab-charm.js": "./pages/activity/newWeeklyStar/tab-charm.js",
	"./activity/newWeeklyStar/tab-reward.js": "./pages/activity/newWeeklyStar/tab-reward.js",
	"./activity/newWeeklyStar/tab-wealth.js": "./pages/activity/newWeeklyStar/tab-wealth.js",
	"./activity/pkactivity/Countdown/index.js": "./pages/activity/pkactivity/Countdown/index.js",
	"./activity/pkactivity/Countdown2/index.js": "./pages/activity/pkactivity/Countdown2/index.js",
	"./activity/pkactivity/RankLastWeek/index.js": "./pages/activity/pkactivity/RankLastWeek/index.js",
	"./activity/pkactivity/RankThisWeek/index.js": "./pages/activity/pkactivity/RankThisWeek/index.js",
	"./activity/pkactivity/RoomLastWeek/index.js": "./pages/activity/pkactivity/RoomLastWeek/index.js",
	"./activity/pkactivity/RoomThisWeek/index.js": "./pages/activity/pkactivity/RoomThisWeek/index.js",
	"./activity/pkactivity/RuleReminder/index.js": "./pages/activity/pkactivity/RuleReminder/index.js",
	"./activity/pkactivity/index.js": "./pages/activity/pkactivity/index.js",
	"./activity/pkactivity/lang.js": "./pages/activity/pkactivity/lang.js",
	"./activity/pkactivity/pkReward/index.js": "./pages/activity/pkactivity/pkReward/index.js",
	"./activity/ramadan/index.js": "./pages/activity/ramadan/index.js",
	"./activity/ramadan/lang.js": "./pages/activity/ramadan/lang.js",
	"./activity/ramadanHelp/index.js": "./pages/activity/ramadanHelp/index.js",
	"./activity/ramadanHelp/lang.js": "./pages/activity/ramadanHelp/lang.js",
	"./activity/ramadanJigsaw/index.js": "./pages/activity/ramadanJigsaw/index.js",
	"./activity/ramadanJigsaw/lang.js": "./pages/activity/ramadanJigsaw/lang.js",
	"./activity/rechargenew/countdown/index.js": "./pages/activity/rechargenew/countdown/index.js",
	"./activity/rechargenew/index.js": "./pages/activity/rechargenew/index.js",
	"./activity/rechargenew/lang.js": "./pages/activity/rechargenew/lang.js",
	"./activity/ruby-activity/Rule/index.js": "./pages/activity/ruby-activity/Rule/index.js",
	"./activity/ruby-activity/index.js": "./pages/activity/ruby-activity/index.js",
	"./activity/ruby-activity/lang.js": "./pages/activity/ruby-activity/lang.js",
	"./activity/rulersRoot/index.js": "./pages/activity/rulersRoot/index.js",
	"./activity/rulersRoot/lang.js": "./pages/activity/rulersRoot/lang.js",
	"./activity/test/index.js": "./pages/activity/test/index.js",
	"./activity/test/lang.js": "./pages/activity/test/lang.js",
	"./activity/test2/index.js": "./pages/activity/test2/index.js",
	"./activity/valentineDay/index.js": "./pages/activity/valentineDay/index.js",
	"./activity/valentineDay/lang.js": "./pages/activity/valentineDay/lang.js",
	"./activity/valentineDay/thumbsUp/index.js": "./pages/activity/valentineDay/thumbsUp/index.js",
	"./activity/valentineDay/thumbsUp/lang.js": "./pages/activity/valentineDay/thumbsUp/lang.js",
	"./activity/valentineDay/topLovers/index.js": "./pages/activity/valentineDay/topLovers/index.js",
	"./activity/valentineDay/topLovers/lang.js": "./pages/activity/valentineDay/topLovers/lang.js",
	"./activity/weeklyStar/index.js": "./pages/activity/weeklyStar/index.js",
	"./activity/weeklyStar/lang.js": "./pages/activity/weeklyStar/lang.js",
	"./activity/welfare-user/index.js": "./pages/activity/welfare-user/index.js",
	"./activity/welfare/index.js": "./pages/activity/welfare/index.js",
	"./admin-control/admin-control-panel/index.js": "./pages/admin-control/admin-control-panel/index.js",
	"./admin-control/admin-control-panel/lang.js": "./pages/admin-control/admin-control-panel/lang.js",
	"./admin-control/admin-control-user/index.js": "./pages/admin-control/admin-control-user/index.js",
	"./admin-control/admin-control-user/lang.js": "./pages/admin-control/admin-control-user/lang.js",
	"./admin-control/agency_create/index.js": "./pages/admin-control/agency_create/index.js",
	"./admin-control/agency_create/lang.js": "./pages/admin-control/agency_create/lang.js",
	"./admin-control/bane-reset-room/index.js": "./pages/admin-control/bane-reset-room/index.js",
	"./admin-control/bane-reset-room/lang.js": "./pages/admin-control/bane-reset-room/lang.js",
	"./admin-control/bane-reset-userdata/index.js": "./pages/admin-control/bane-reset-userdata/index.js",
	"./admin-control/bane-reset-userdata/lang.js": "./pages/admin-control/bane-reset-userdata/lang.js",
	"./admin-control/bane-reset/index.js": "./pages/admin-control/bane-reset/index.js",
	"./admin-control/bane-reset/lang.js": "./pages/admin-control/bane-reset/lang.js",
	"./admin-control/guild/index.js": "./pages/admin-control/guild/index.js",
	"./admin-control/guild/lang.js": "./pages/admin-control/guild/lang.js",
	"./admin-control/newBaneReset/index.js": "./pages/admin-control/newBaneReset/index.js",
	"./admin-control/newBaneReset/lang.js": "./pages/admin-control/newBaneReset/lang.js",
	"./app/agentgold/index.js": "./pages/app/agentgold/index.js",
	"./app/agentgold/lang.js": "./pages/app/agentgold/lang.js",
	"./app/agentlogin/index.js": "./pages/app/agentlogin/index.js",
	"./app/agentlogin/lang.js": "./pages/app/agentlogin/lang.js",
	"./app/appgames/index.js": "./pages/app/appgames/index.js",
	"./app/appgames/lang.js": "./pages/app/appgames/lang.js",
	"./app/child_safety_policy/index.js": "./pages/app/child_safety_policy/index.js",
	"./app/child_safety_policy_voca/index.js": "./pages/app/child_safety_policy_voca/index.js",
	"./app/couples/index.js": "./pages/app/couples/index.js",
	"./app/datacenter/index.js": "./pages/app/datacenter/index.js",
	"./app/datacenter/lang.js": "./pages/app/datacenter/lang.js",
	"./app/deleteapp/index.js": "./pages/app/deleteapp/index.js",
	"./app/deleteapp_voca/index.js": "./pages/app/deleteapp_voca/index.js",
	"./app/duid/index.js": "./pages/app/duid/index.js",
	"./app/duid/lang.js": "./pages/app/duid/lang.js",
	"./app/find-hostJoin/index.js": "./pages/app/find-hostJoin/index.js",
	"./app/find-hostJoin/lang.js": "./pages/app/find-hostJoin/lang.js",
	"./app/game-1/index.js": "./pages/app/game-1/index.js",
	"./app/game-1/lang.js": "./pages/app/game-1/lang.js",
	"./app/game-FruitSlots/index.js": "./pages/app/game-FruitSlots/index.js",
	"./app/game-FruitSlots/lang.js": "./pages/app/game-FruitSlots/lang.js",
	"./app/game-baisun-v2/index.js": "./pages/app/game-baisun-v2/index.js",
	"./app/game-baisun-v2/lang.js": "./pages/app/game-baisun-v2/lang.js",
	"./app/game-baisun/index.js": "./pages/app/game-baisun/index.js",
	"./app/game-baisun/lang.js": "./pages/app/game-baisun/lang.js",
	"./app/game-box/index.js": "./pages/app/game-box/index.js",
	"./app/game-box/lang.js": "./pages/app/game-box/lang.js",
	"./app/game-cofing/index.js": "./pages/app/game-cofing/index.js",
	"./app/game-cofing/lang.js": "./pages/app/game-cofing/lang.js",
	"./app/game-hkys/index.js": "./pages/app/game-hkys/index.js",
	"./app/game-hkys/lang.js": "./pages/app/game-hkys/lang.js",
	"./app/game-reyou/index.js": "./pages/app/game-reyou/index.js",
	"./app/game-reyou/lang.js": "./pages/app/game-reyou/lang.js",
	"./app/gashapon/LoadingComp/index.js": "./pages/app/gashapon/LoadingComp/index.js",
	"./app/gashapon/RankView/index.js": "./pages/app/gashapon/RankView/index.js",
	"./app/gashapon/ResultPopUp/index.js": "./pages/app/gashapon/ResultPopUp/index.js",
	"./app/gashapon/RewardView/index.js": "./pages/app/gashapon/RewardView/index.js",
	"./app/gashapon/index.js": "./pages/app/gashapon/index.js",
	"./app/gashapon/lang.js": "./pages/app/gashapon/lang.js",
	"./app/giftcodeview/index.js": "./pages/app/giftcodeview/index.js",
	"./app/giftcodeview/lang.js": "./pages/app/giftcodeview/lang.js",
	"./app/goldRecold/index.js": "./pages/app/goldRecold/index.js",
	"./app/goldRecold/lang.js": "./pages/app/goldRecold/lang.js",
	"./app/gotowallet/index.js": "./pages/app/gotowallet/index.js",
	"./app/gotowallet/lang.js": "./pages/app/gotowallet/lang.js",
	"./app/hobiHost/index.js": "./pages/app/hobiHost/index.js",
	"./app/hobiHost/lang.js": "./pages/app/hobiHost/lang.js",
	"./app/hobiMemberCoins/index.js": "./pages/app/hobiMemberCoins/index.js",
	"./app/hobiMemberCoins/lang.js": "./pages/app/hobiMemberCoins/lang.js",
	"./app/host-Info/index.js": "./pages/app/host-Info/index.js",
	"./app/host-Info/lang.js": "./pages/app/host-Info/lang.js",
	"./app/host-invitation/index.js": "./pages/app/host-invitation/index.js",
	"./app/host-invitation/lang.js": "./pages/app/host-invitation/lang.js",
	"./app/host-member/index.js": "./pages/app/host-member/index.js",
	"./app/host-member/lang.js": "./pages/app/host-member/lang.js",
	"./app/invitation/index.js": "./pages/app/invitation/index.js",
	"./app/invitation/lang.js": "./pages/app/invitation/lang.js",
	"./app/invite-member/index.js": "./pages/app/invite-member/index.js",
	"./app/invite-member/lang.js": "./pages/app/invite-member/lang.js",
	"./app/invite-new-host/index.js": "./pages/app/invite-new-host/index.js",
	"./app/invite-new-host/lang.js": "./pages/app/invite-new-host/lang.js",
	"./app/join-application/index.js": "./pages/app/join-application/index.js",
	"./app/join-application/lang.js": "./pages/app/join-application/lang.js",
	"./app/livetimeMic/index.js": "./pages/app/livetimeMic/index.js",
	"./app/livetimeMic/lang.js": "./pages/app/livetimeMic/lang.js",
	"./app/lottery/index.js": "./pages/app/lottery/index.js",
	"./app/lottery/lang.js": "./pages/app/lottery/lang.js",
	"./app/managementGo/index.js": "./pages/app/managementGo/index.js",
	"./app/managementGo/lang.js": "./pages/app/managementGo/lang.js",
	"./app/mine/index.js": "./pages/app/mine/index.js",
	"./app/mine/lang.js": "./pages/app/mine/lang.js",
	"./app/moment/index.js": "./pages/app/moment/index.js",
	"./app/moment/lang.js": "./pages/app/moment/lang.js",
	"./app/newChangeEmtyp/index.js": "./pages/app/newChangeEmtyp/index.js",
	"./app/newChangeEmtyp/lang.js": "./pages/app/newChangeEmtyp/lang.js",
	"./app/newGoldRecold/index.js": "./pages/app/newGoldRecold/index.js",
	"./app/newGoldRecold/lang.js": "./pages/app/newGoldRecold/lang.js",
	"./app/newInvitation/index.js": "./pages/app/newInvitation/index.js",
	"./app/newInvitation/lang.js": "./pages/app/newInvitation/lang.js",
	"./app/newTestPic/index.js": "./pages/app/newTestPic/index.js",
	"./app/newTestPic/lang.js": "./pages/app/newTestPic/lang.js",
	"./app/newpaypal/index.js": "./pages/app/newpaypal/index.js",
	"./app/newpaypal/lang.js": "./pages/app/newpaypal/lang.js",
	"./app/nopaypal/index.js": "./pages/app/nopaypal/index.js",
	"./app/nopaypal/lang.js": "./pages/app/nopaypal/lang.js",
	"./app/partycreate/index.js": "./pages/app/partycreate/index.js",
	"./app/partyroom/index.js": "./pages/app/partyroom/index.js",
	"./app/partysub/index.js": "./pages/app/partysub/index.js",
	"./app/privacypolicy/index.js": "./pages/app/privacypolicy/index.js",
	"./app/privacypolicy_ios/index.js": "./pages/app/privacypolicy_ios/index.js",
	"./app/privacypolicy_voca/index.js": "./pages/app/privacypolicy_voca/index.js",
	"./app/recharge/index.js": "./pages/app/recharge/index.js",
	"./app/recharge/lang.js": "./pages/app/recharge/lang.js",
	"./app/rechargebonus/index.js": "./pages/app/rechargebonus/index.js",
	"./app/rechargebonus/lang.js": "./pages/app/rechargebonus/lang.js",
	"./app/refund/index.js": "./pages/app/refund/index.js",
	"./app/refund/lang.js": "./pages/app/refund/lang.js",
	"./app/roomreward/index.js": "./pages/app/roomreward/index.js",
	"./app/roomreward/lang.js": "./pages/app/roomreward/lang.js",
	"./app/roomsupport-op/AwardUserList/index.js": "./pages/app/roomsupport-op/AwardUserList/index.js",
	"./app/roomsupport-op/GetUsers/index.js": "./pages/app/roomsupport-op/GetUsers/index.js",
	"./app/roomsupport-op/LastWeekAward/index.js": "./pages/app/roomsupport-op/LastWeekAward/index.js",
	"./app/roomsupport-op/Owner/index.js": "./pages/app/roomsupport-op/Owner/index.js",
	"./app/roomsupport-op/ReportTitle/index.js": "./pages/app/roomsupport-op/ReportTitle/index.js",
	"./app/roomsupport-op/ReportTitle2/index.js": "./pages/app/roomsupport-op/ReportTitle2/index.js",
	"./app/roomsupport-op/RoomGold/index.js": "./pages/app/roomsupport-op/RoomGold/index.js",
	"./app/roomsupport-op/Sign/index.js": "./pages/app/roomsupport-op/Sign/index.js",
	"./app/roomsupport-op/adminRoomList/index.js": "./pages/app/roomsupport-op/adminRoomList/index.js",
	"./app/roomsupport-op/index.js": "./pages/app/roomsupport-op/index.js",
	"./app/roomsupport-op/lang.js": "./pages/app/roomsupport-op/lang.js",
	"./app/roomsupport/GroupList/index.js": "./pages/app/roomsupport/GroupList/index.js",
	"./app/roomsupport/Nav/index.js": "./pages/app/roomsupport/Nav/index.js",
	"./app/roomsupport/Reward/index.js": "./pages/app/roomsupport/Reward/index.js",
	"./app/roomsupport/Rule/index.js": "./pages/app/roomsupport/Rule/index.js",
	"./app/roomsupport/Top/index.js": "./pages/app/roomsupport/Top/index.js",
	"./app/roomsupport/index.js": "./pages/app/roomsupport/index.js",
	"./app/roomsupport/lang.js": "./pages/app/roomsupport/lang.js",
	"./app/roomsupport2/index.js": "./pages/app/roomsupport2/index.js",
	"./app/ruby-agent/index.js": "./pages/app/ruby-agent/index.js",
	"./app/ruby-agent/lang.js": "./pages/app/ruby-agent/lang.js",
	"./app/ruby-join/index.js": "./pages/app/ruby-join/index.js",
	"./app/ruby-join/lang.js": "./pages/app/ruby-join/lang.js",
	"./app/ruby-monopoly-main/index.js": "./pages/app/ruby-monopoly-main/index.js",
	"./app/ruby-monopoly-main/lang.js": "./pages/app/ruby-monopoly-main/lang.js",
	"./app/ruby-monopoly/Copyright/index.js": "./pages/app/ruby-monopoly/Copyright/index.js",
	"./app/ruby-monopoly/Countdown/index.js": "./pages/app/ruby-monopoly/Countdown/index.js",
	"./app/ruby-monopoly/GroupList/index.js": "./pages/app/ruby-monopoly/GroupList/index.js",
	"./app/ruby-monopoly/List/index.js": "./pages/app/ruby-monopoly/List/index.js",
	"./app/ruby-monopoly/Nav/index.js": "./pages/app/ruby-monopoly/Nav/index.js",
	"./app/ruby-monopoly/Nav2/index.js": "./pages/app/ruby-monopoly/Nav2/index.js",
	"./app/ruby-monopoly/Prize/index.js": "./pages/app/ruby-monopoly/Prize/index.js",
	"./app/ruby-monopoly/Rule/index.js": "./pages/app/ruby-monopoly/Rule/index.js",
	"./app/ruby-monopoly/Share/index.js": "./pages/app/ruby-monopoly/Share/index.js",
	"./app/ruby-monopoly/Top/index.js": "./pages/app/ruby-monopoly/Top/index.js",
	"./app/ruby-monopoly/index.js": "./pages/app/ruby-monopoly/index.js",
	"./app/ruby-monopoly/lang.js": "./pages/app/ruby-monopoly/lang.js",
	"./app/ruby/index.js": "./pages/app/ruby/index.js",
	"./app/ruby/lang.js": "./pages/app/ruby/lang.js",
	"./app/service/Modal/index.js": "./pages/app/service/Modal/index.js",
	"./app/service/Nav/index.js": "./pages/app/service/Nav/index.js",
	"./app/service/Snap/index.js": "./pages/app/service/Snap/index.js",
	"./app/service/Video/index.js": "./pages/app/service/Video/index.js",
	"./app/service/faqContent.js": "./pages/app/service/faqContent.js",
	"./app/service/feedback.js": "./pages/app/service/feedback.js",
	"./app/service/feedbackContent.js": "./pages/app/service/feedbackContent.js",
	"./app/service/index.js": "./pages/app/service/index.js",
	"./app/service/lang.js": "./pages/app/service/lang.js",
	"./app/share/index.js": "./pages/app/share/index.js",
	"./app/share/lang.js": "./pages/app/share/lang.js",
	"./app/slotruby/index.js": "./pages/app/slotruby/index.js",
	"./app/slotruby/lang.js": "./pages/app/slotruby/lang.js",
	"./app/teamsofservice/index.js": "./pages/app/teamsofservice/index.js",
	"./app/teamsofservice_ios/index.js": "./pages/app/teamsofservice_ios/index.js",
	"./app/terms/index.js": "./pages/app/terms/index.js",
	"./app/termsofuse/index.js": "./pages/app/termsofuse/index.js",
	"./app/tradeUnion/index.js": "./pages/app/tradeUnion/index.js",
	"./app/tradeUnion/lang.js": "./pages/app/tradeUnion/lang.js",
	"./app/voca-terms/index.js": "./pages/app/voca-terms/index.js",
	"./home/about/index.js": "./pages/home/about/index.js",
	"./home/mobile/index.js": "./pages/home/mobile/index.js",
	"./home/pc/index.js": "./pages/home/pc/index.js",
	"./ludo/gamerule/index.js": "./pages/ludo/gamerule/index.js",
	"./ludo/gamerule/lang.js": "./pages/ludo/gamerule/lang.js",
	"./ludo/ludohistory/index.js": "./pages/ludo/ludohistory/index.js",
	"./ludo/ludorank/index.js": "./pages/ludo/ludorank/index.js",
	"./ludo/ludorule/Classic/index.js": "./pages/ludo/ludorule/Classic/index.js",
	"./ludo/ludorule/Master/index.js": "./pages/ludo/ludorule/Master/index.js",
	"./ludo/ludorule/Quick/index.js": "./pages/ludo/ludorule/Quick/index.js",
	"./ludo/ludorule/index.js": "./pages/ludo/ludorule/index.js",
	"./ludo/ludorule/lang.js": "./pages/ludo/ludorule/lang.js",
	"./oauth/callback/index.js": "./pages/oauth/callback/index.js",
	"./test/iframe1/index.js": "./pages/test/iframe1/index.js",
	"./test/iframe1/lang.js": "./pages/test/iframe1/lang.js",
	"./test/iframe2/index.js": "./pages/test/iframe2/index.js",
	"./test/iframe2/lang.js": "./pages/test/iframe2/lang.js",
	"./test/test/index.js": "./pages/test/test/index.js",
	"./test/test2/test.js": "./pages/test/test2/test.js",
	"./test/webview/index.js": "./pages/test/webview/index.js",
	"./voca-home/lang.js": "./pages/voca-home/lang.js",
	"./voca-home/mobile/index.js": "./pages/voca-home/mobile/index.js",
	"./voca-home/pc/index.js": "./pages/voca-home/pc/index.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./pages recursive ^\\.\\/.*\\.js$";


//////////////////
// WEBPACK FOOTER
// ./pages ^\.\/.*\.js$
// module id = ./pages recursive ^\.\/.*\.js$
// module chunks = 0